import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_api,
});

const axiosApi = axios.create({
  baseURL: process.env.REACT_APP_api,
  auth: {
    username: process.env.REACT_APP_apiUsername,
    password: process.env.REACT_APP_apiPassword,
  },
  headers: {
    'Content-Type': 'application/json',
    byCompany: process.env.REACT_APP_WHITE_LABEL,
  },
});

export { axiosInstance as axios, axiosApi };
